import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
//import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate, useParams } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { GlobalDataContext } from "contexts/GlobalData";
import { requestAPI } from "utils/api";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";
import Label from "components/Label/Label";
import { UIContext } from "contexts/UIContext";


// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ReservationModifyEtc: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const { id, idx } = useParams();

	const navigate = useNavigate ();

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const {
		toast,
	} = useContext(UIContext);  

	const [ tourMethod, setTourMethod ] = useState <any> ("0");	
	const [ disease, setDisease ] = useState <any> ("0");
	const [ diseaseText, setDiseaseText ] = useState <any> ("");
	const [ mileage, setMileage ] = useState <any> ("0");
	const [ drivingExperience, setDrivingExperience ] = useState <any> ("0");

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate(`/reservation/${id}`)	
		} else {
			(async () => {

				const res: any = await requestAPI('GET', `v1/reserve/${id}`, null);

				const traveler = res.data.info.traveler[Number(idx)];

				setTourMethod(
					(traveler.etc.tourMethod === null)
					? "0" 
					: traveler.etc.tourMethod
				);

				if (traveler.etc.disease === null) {
					
				} else if (traveler.etc.disease === "1") {
					setDisease("1");

				} else {
					setDisease("2");
					setDiseaseText(traveler.etc.disease);
				}

				setMileage(
					(traveler.etc.mileage === null)
					? "0" 
					: traveler.etc.mileage
				);

				setDrivingExperience(
					(traveler.etc.drivingExperience === null)
					? "0" 
					: traveler.etc.drivingExperience
				)
			})();
		}
		
	}, []);
	
	
	const handleSubmit = async () => {

		let _disease = "";

		if (disease === "0") {
			return toast ({type: 'warning', contents: "지병 정보를 선택해 주세요"});
		 
		} else if (tourMethod === "0") {
			return toast ({type: 'warning', contents: "투어 방법을 선택해 주세요"});	
		} else if (drivingExperience === "0") {
			return toast ({type: 'warning', contents: "투어 경력을 선택해 주세요"});	
		} else if (mileage === "0") {
			return toast ({type: 'warning', contents: "장거리 주행 경험을 선택해 주세요"});

		}
		if(disease === "2") {
			_disease = diseaseText;
		} else {
			_disease = disease;
		}

		//v1_reserve_var_traveler_var_put
		const res_info: any = await requestAPI ('PUT', `v1/reserve/${id}/traveler-etc/${idx}`, {
			tourMethod,
			disease: _disease,
			mileage,
			drivingExperience
		});

		if (res_info.code === 1000) {

			navigate(`/reservation/${id}`)	
		}
	};
	
	

	const handleBack = () => {
		navigate(`/reservation/${id}`)	
	}

	const handleChange = (type: string, value: string) => {

		switch(type) {
			case "drivingExperience": 
				setDrivingExperience(value);
				break;
			case "mileage":
				setMileage(value);
				break;
			case "tourMethod":
				setTourMethod(value);
				break;
			case "disease":
				setDisease(value);
				break;
			case "diseaseText":
				setDiseaseText(value);
				break;
		}
		
	};

	return (
		<>
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>
				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									여행에 필요한 정보
								</h2>
							</div>
						</div>

						<div className="mt-10" />
						<div className="flex">
							<div>
								{/* <Label className="text-[1.1rem]">평소 앓고 있는 지병이 있나요</Label> */}
								<span
									className="text-xl font-semibold text-slate-600 mt-2"
								>
									평소 앓고 있는 지병이 있나요
								</span>
								<div className="mt-1" />
								<select
									value={disease}
									onChange={e => handleChange("disease", e.target.value)}
									className={`"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
								>
									<option
										value={"0"}
									>
										설정 없음
									</option>		
									<option

										value={"1"}
									>
										질병 없음
									</option>		
									<option
										value={"2"}
									>
										질병 있음
									</option>		
								</select>
							</div>				
						</div>


						{disease==="2"
						?
							<>
								<div className="mt-10" />
								<div className="flex">
									<div>
										{/* <Label className="text-[1.1rem]">평소 앓고 있는 지병이 있나요</Label> */}
										<span
											className="text-xl font-semibold text-slate-600 mt-2"
										>
											질병에 대해 작성해 주세요
										</span>
										<textarea 
											value={diseaseText}
											onChange={e => handleChange("diseaseText", e.target.value)}
										/>
									</div>				
								</div>
							</>
						:
							""
						}

						<div className="mt-5" />
						<div className="flex">
							<div>
								<span
									className="text-xl font-semibold text-slate-600 mt-2"
								>
									투어방법
								</span>
								<div className="mt-1" />
								<select
									value={tourMethod}
									onChange={e => handleChange("tourMethod", e.target.value)}
									className={`"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
								>
									<option
										value={"0"}
									>
										설정 없음
									</option>		
									<option

										value={"1"}
									>
										라이딩
									</option>		
									<option
										value={"2"}
									>
										텐덤 (운전안함)
									</option>		
									<option
										value={"3"}
									>
										라이딩 및 텐덤
									</option>		
								</select>
							</div>				
						</div>
						
						
						
							
						<div className="mt-5" />
						<div className="flex">
							<div>
								<span
									className="text-xl font-semibold text-slate-600 mt-2"
								>
									경력
								</span>
								<div className="mt-1" />
								<div>
									<select
										value={drivingExperience}
										onChange={e => handleChange("drivingExperience", e.target.value)}
										className={`"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
									>
										<option
											value={"0"}
											>
											설정 없음
										</option>	
										<option
											value={"1"}
										>
											경력없음
										</option>		
										<option

											value={"2"}
										>
											1년 미만
										</option>		
										<option
											value={"3"}
										>
											1년 이상 3년 미만
										</option>		
										<option
											value={"4"}
										>
											3년 이상 5년 미만
										</option>		
										<option
											value={"5"}
										>
											5년 이상 10년 미만
										</option>		
										<option
											value={"6"}
										>
											10년 이상
										</option>		
									</select>
								</div>
							</div>				
						</div>

						<div className="mt-5" />
						<div className="flex mt-5">
							<div>
								<span
									className="text-xl font-semibold text-slate-600 mt-2"
								>
									장거리 주행(1,000km 이상) 경험이 있으신가요?
								</span>
								<div className="mt-1" />
								<div>
									<select
										value={mileage}
										onChange={e => handleChange("mileage", e.target.value)}
										className={`"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:max-w-xs sm:text-sm sm:leading-6`}
									>
										<option
											value={"0"}
										>
											설정 없음
										</option>		
										<option
											value={"1"}
										>
											있음
										</option>		
										<option
											value={"2"}
										>
											없음
										</option>		
									</select>
								</div>
							</div>				
						</div>
						
						
						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>						
						

					</div>

				</div>
				
			</div>
		</>
	);
};

export default ReservationModifyEtc;
